import React, { useState, useEffect } from 'react'

import {
  Row,
  Col,
  Steps,
  Form,
  Input,
  Select,
  DatePicker,
  Card,
  Upload,
  Button,
  Modal,
  Checkbox,
} from 'antd'
import styled from 'styled-components'
import { getCookie } from 'helper/cookie'
import {
  updateCheckList,
  saveCheckList,
  deleteCheckList,
  getResultCheckList,
  optionCheckList,
} from 'api/Project/checklist'

import lang from 'lang/en'

const initalState = {
  data: [],
  isLoading: true,
}

const CheckList = (props) => {
  // console.log(props.setCheckbtn)

  const { idEditPRJ } = props
  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [formAddChecklist] = Form.useForm()

  const [dataOptionChecklist, setDataOptionChecklist] = useState(initalState.data)

  const onFinish = (values) => {

    props.setModalVisionaddChecklist(false)
    if (values.addchecklistrequire == '' || values.addchecklistrequire == null) {
      values.addchecklistrequire = 'N'
    } else {
      values.addchecklistrequire = 'Y'
    }
    const dataArrayAddCheckList = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: props.id,
      title: values.addnamechecklist,
      checklist_type_id: values.addselectchecklist,
      required: values.addchecklistrequire,
    }

    saveCheckList({
      params: dataArrayAddCheckList,
      token: token,
    }).then((response) => {
      if (response.status === 200) {
        props.setCheckbtn('')

        props.getDataCheckList()
        formAddChecklist.setFieldsValue({
          addselectchecklist: null,
          addnamechecklist: null,
          addchecklistrequire: null,
        })
      }
    })
  }

  //get option chceklist
  const getDataOptionCheckList = async () => {
    await optionCheckList({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataOptionChecklist([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataOptionChecklist(data)
          await setIsLoading(false)
        } else {
          setDataOptionChecklist([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOptionChecklist([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (props.modalVisionaddChecklist) {
      getDataOptionCheckList()

      return () => {
        // getDataOptionCheckList()
      }
    }
  }, [props.modalVisionaddChecklist])

  const cancel = () => {
    props.setModalVisionaddChecklist(false)
    props.setCheckbtn('')
    formAddChecklist.setFieldsValue({
      addselectchecklist: null,
      addnamechecklist: null,
      addchecklistrequire: null,
    })
  }

  return (
    <Form form={formAddChecklist} name="SaveChecklist" onFinish={onFinish}>
      <Modal
        maskClosable={false}
        destroyOnClose={true}
        className="checklistmodal"
        title={
          <h2 style={{ color: '#127EC3' }}>
            {word['addtask_information_btn_checklist_addnew']}
          </h2>
        }
        visible={props.modalVisionaddChecklist}
        onOk={formAddChecklist.submit}
        onCancel={cancel}
        okText="Save"
      >
        <h4>{word['addtask_information_title_modal_checklist_type']}</h4>
        <div style={{ paddingTop: 8 }}>
          <Form.Item
            name="addselectchecklist"
            rules={[
              {
                required: true,
                message: word['addtask_information_checklist_Type_Checklist'],
              },
            ]}
          >
            <Select placeholder="Type Checklist" style={{ width: 586 }} size="large">
              {dataOptionChecklist.map((item) => (
                <Option value={item.id} dataselect={item}>
                  {item.name_en}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        <h4 style={{ paddingTop: 24 }}>
          {word['addtask_information_title_modal_checklist_name']}
        </h4>
        <div style={{ paddingTop: 8 }}>
          <Form.Item
            name="addnamechecklist"
            rules={[
              {
                whitespace: true,
                required: true,
                message: word['addtask_information_checklist_Name_Checklist'],
              },
            ]}
          >
            <Input
              className="input"
              style={{ width: 586 }}
              placeholder="Name"
              size="large"
            ></Input>
          </Form.Item>
        </div>

        {/* <div style={{ paddingTop: 24 }}> */}
        <Form.Item name="addchecklistrequire">
          <Checkbox.Group style={{ paddingTop: 10 }}>
            <Checkbox value="Y">
              {word['addtask_information_title_modal_checklist_required']}
            </Checkbox>
          </Checkbox.Group>
        </Form.Item>
      </Modal>
    </Form>
  )
}
export default CheckList
